// extracted by mini-css-extract-plugin
export default {"LiveScoreFixtures":"LiveScoreLeague_LiveScoreFixtures__fdSyi"};